<template>
  <Layout>
    <div class="ocpp-configuration-main">

      <b-tabs content-class="tab-content-zone text-muted" nav-class="nav-tabs-custom"
              :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">
        <b-tab v-for="(tab, i) in tabs" :key="i" :active="i === 0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i :class="`mdi ${tab.icon}`" />
            </span>
            <span class="d-none d-sm-inline-block">
              <i :class="`mdi ${tab.icon} icon-padding-right`" />
            </span>
            <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
          </template>
          <component :is="tab.component" :key="i" />
        </b-tab>
      </b-tabs>

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main.vue';

import ChargePoint from '@/views/pages/ocpp/configuration/chargePoint.vue';
import Profile from '@/views/pages/ocpp/configuration/profile.vue';
import IdTag from '@/views/pages/ocpp/configuration/idTag.vue';

export default {
  components: { Layout, ChargePoint, Profile, IdTag },
  data() {
    return {
      tabs: [
        { title: 'Charge Point', icon: 'mdi-ev-station', component: 'ChargePoint' },
        { title: 'Profile', icon: 'mdi-content-paste', component: 'Profile' },
        { title: 'ID Tag', icon: 'mdi-smart-card', component: 'IdTag' }
      ]
    }
  }
}
</script>
